import { render } from "./GovernmentAndEnterpriseOffice.vue?vue&type=template&id=ac275fd2&scoped=true"
import script from "./GovernmentAndEnterpriseOffice.vue?vue&type=script&lang=js"
export * from "./GovernmentAndEnterpriseOffice.vue?vue&type=script&lang=js"

import "../style/buildingDevelopment.scss?vue&type=style&index=0&id=ac275fd2&lang=scss&scoped=true&external"
import "../style/common.scss?vue&type=style&index=1&id=ac275fd2&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac275fd2"]])

export default __exports__